import styled, { keyframes } from 'styled-components';

/* shimmer */
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    #d1d5db 25%,
    #c7cbd1 37%,
    #d1d5db 63%
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: 6px;
`;

/* Container */
export const SummaryContainer = styled.div`
  margin-top: 24px;
  padding-bottom: 20px;
`;

/* Title */
export const TitleSkeleton = styled(SkeletonBase)`
  width: 140px;
  height: 24px;
  margin-bottom: 16px;
`;

/* Box (igual ao classic) */
export const SummaryBox = styled.div`
  background: #ededed;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  position: relative;
  padding-bottom: 30px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-image:
      radial-gradient(circle at 10px 10px, white 10px, #ededed 10px);
    background-size: 20px 20px;
    background-position: 0 0;
    background-repeat: repeat-x;
  }
`;

/* Item */
export const SummaryItem = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/* Divider */
export const Divider = styled.div`
  border-top: 2px solid #ccc;
  margin: 16px 0;
`;

/* Total */
export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/* Text */
export const TextSkeleton = styled(SkeletonBase)<{
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height ?? '14px'};
`;